<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton
        :loading="isFetchingMailto"
        :href="href"
        color="primary"
        class="send-offer-message-btn"
      >
        <v-img
          src="@/assets/svg/send_offer_message.svg"
          class="offer-icon"
          size="50"
        />
        <span :class="{ 'ml-1': isMobile }"> Send Offer Message </span>
      </SecondaryButton>
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { FETCH_OFFER_MAILTO } from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "SendOfferMessageAction",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    SecondaryButton,
    BaseAction
  },
  async created() {
    this.href = await this.fetchOfferMailto(this.id);
  },
  data() {
    return {
      href: "mailto:"
    };
  },
  computed: {
    ...mapState(["isFetchingMailto"])
  },
  methods: {
    ...mapActions({
      fetchOfferMailto: FETCH_OFFER_MAILTO
    }),
    onSubmit() {
      this.$router.push({
        name: "newConversation",
        params: {
          selectedOfferId: this.id
        }
      });
    }
  }
};
</script>
<style lang="scss">
.offer-icon {
  width: 33px;
  height: 26px;
  margin: auto auto 2px auto;
}

.secondary-button.send-offer-message-btn {
  height: 80px !important;

  @media only screen and (max-width: $mobile-breakpoint - 1px) {
    height: auto !important;
    padding: 15px !important;
    min-height: 40px !important;
    justify-content: flex-start !important;
  }
}
</style>
